import { hex2ustring } from "./hex";
// v2
export const VER_CATTLE = hex2ustring('00760032');
// v3
export const VER_TIGER = hex2ustring('00760033');
